/* eslint-disable no-unreachable */ //TODO: to remove before JOP PR
import React from 'react';
import useForm from '../utils/useForm';
import NeoInput from '../components/neoInput';
import NeoLayout from '../components/neoLayout';
import {get_validator, get_validators} from '../utils/validators';

import { useRuntimeContext } from '../context/runtime-context';

export const generate_use_form_schema = (spec) => {
    let schema = {};
    // validator is deprecated
    for (let { key, allow_blank, required, default_value, type, validator, validators_list, value=null, conditional_display={} } of spec) { // eslint-disable-line no-unused-vars
        if(['submit_button', 'reset_button'].includes(type)){
            // these types do not have input
            continue;
        }
        schema[key] = {
            validator: get_validator(type, validator),//deprecated
            validators: get_validators(validators_list),
            conditional_display,
            required,
            allow_blank,
            value: value
        }
    }

    return schema;
}

export default function FormStep({ step, config, onSubmit, widgetKey=null, storage, isSubmitting }) {
    const { form: spec } = config;

    const { addContext } = useRuntimeContext();

    const onFormChange = React.useCallback(form => {
        addContext({ form });
    }, [addContext]);

    let schema = React.useRef(generate_use_form_schema(spec));
    const [form, setFormValue, , , errors, validateForm] = useForm(schema.current, {
        validateOnChange: false,
        clearOnChange: true,
        onChange: onFormChange
    });

    // Render form
    let fields = spec.map(({ key, label, placeholder, type, validator, value_type='', description, props={}, ...rest }, index) => {
        if (['submit_button', 'reset_button'].includes(type)) {
            return null;
        }

        return <NeoInput
            key={key}
            type={type}
            label={label}
            placeholder={placeholder}
            onChange={(value) => setFormValue(key, value)}
            setFormValue={setFormValue}
            error={errors[key]}
            valueType={value_type}
            validator={get_validator(type, validator)}
            description={description}
            currentValue={form[key]}
            {...props}
            {...rest}
        />
    });

    const submit = React.useCallback(event => {
        if (!event) {
            return;
        }

        if (!event.preventDefault){
            return onSubmit(event)
        }
        event.preventDefault();

        let { valid } = validateForm();
        if (valid) {
            return onSubmit({ form });
        }
    }, [onSubmit, form, validateForm]);

    let button = spec.find(({ type }) => ['submit_button', 'reset_button'].includes(type));

    // Check required keys to disable send button
    let submitDisabled = false;
    for(let [k, v] of Object.entries(schema.current)) { // eslint-disable-line no-unused-vars
        // Values '' and 0 might be accepted as "non null"
        if(v && v.required && (form[k] === undefined || form[k] === null)) {
            submitDisabled = true;
            break;
        }
    }

    return (
        <form onSubmit={submit}>
            {
                fields.length && <NeoLayout.Content>
                    {fields}
                </NeoLayout.Content>
            }
            <NeoLayout.Footer
                step={step}
                onSubmit={submit}
                submitDisabled={submitDisabled}
                config={button}
                widgetKey={widgetKey}
                storage={storage}
                isSubmitting={isSubmitting}
            />
        </form>
    );
}
